import React, { useEffect } from 'react';
import { useState, useContext } from 'react';
import { UserContext } from '../../context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Label, TextInput } from 'flowbite-react';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../shared/Loader/Loader.js';

const Login = () => {
    const { setState } = useContext(UserContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (auth && auth.user) {
            navigate("/")
        }
    })

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true)
            const { data } = await axios.post(
                `${process.env.REACT_APP_API_URL}/login`,
                {
                    email, password
                });
            setEmail('');
            setPassword('');

            // update context
            setState({
                user: data.user,
                token: data.token,
            });

            // save in local storage
            window.localStorage.setItem("auth", JSON.stringify(data));
            if(data && data.user.userRole === 'Admin'){
                navigate("/shopSelection");
            }else{
                navigate("/")
            }
            toast.success("User LoggedIn Successfully")
            setIsLoading(false)
        } catch (error) {
            toast.error(error.response.data);
            setIsLoading(false)
        }
    }

    return (
        <div>
            {isLoading ? <Loader /> : ''}
            <form className="flex max-w-md flex-col gap-4 mx-auto mt-5" onSubmit={handleSubmit}>
                <div className='mb-10'>
                    <h1 className='text-center text-[#063A73] font-bold text-[1.6rem]'>Currency Exchange</h1>
                    <h2 className='text-center text-[#063A73] font-bold text-[2rem] mt-10'>Login</h2>
                </div>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="email" value="Email" />
                    </div>
                    <TextInput id="email" type="email" placeholder="Enter Your Email" value={email} onChange={e => setEmail(e.target.value)} required shadow />
                </div>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="password" value="Password" />
                    </div>
                    <TextInput id="password" type="password" placeholder="Enter Your Password" value={password} onChange={e => setPassword(e.target.value)} required shadow />
                </div>
                <button disabled={!email || !password} className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg'>Login</button>
            </form>
            <p className="mt-4 text-center text-gray-600 text-sm">
                Don't have an account? <Link to='/register' className="text-blue-600 hover:underline">Sign Up</Link>
            </p>
            <p className="mt-2 text-center text-gray-600 text-sm">
                {/* <Link to='/forgotPassword' className="text-blue-600 hover:underline">Forgot Password?</Link> */}
            </p>
        </div>
    );
}

export default Login;